
import { Suspense } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import VideoBackground from '../../components/base/VideoBackground';
import ProjectCarousel from '../../components/base/ProjectCarousel';

const ProjectsPage = () => {
  const projects = [
    {
      title: 'Bella\'s Boutique',
      category: 'Fashion Retail',
      description: 'Increased Instagram engagement by 340% in 3 months with daily styled outfit posts and behind-the-scenes content.',
      results: ['340% engagement increase', '2,500+ new followers', '45% sales growth'],
      image: 'https://public.readdy.ai/ai/img_res/d10af9dbdff45beba1115717cefd410a.jpg'
    },
    {
      title: 'Green Leaf Cafe',
      category: 'Food & Beverage',
      description: 'Built a thriving social media presence from scratch, showcasing artisan coffee and fresh pastries with mouth-watering photography.',
      results: ['5,000+ followers in 6 months', '200+ daily foot traffic increase', 'Featured in local food blogs'],
      image: 'https://readdy.ai/api/search-image?query=Artisan%20coffee%20shop%20interior%20with%20fresh%20pastries%20display%2C%20warm%20lighting%2C%20cozy%20atmosphere%2C%20professional%20food%20photography%2C%20clean%20white%20background%2C%20modern%20cafe%20aesthetic&width=600&height=400&seq=project2&orientation=landscape'
    },
    {
      title: 'FitLife Gym',
      category: 'Fitness & Wellness',
      description: 'Created motivational content and transformation stories that drove membership sign-ups and community engagement.',
      results: ['150+ new memberships', '500% video view increase', 'Strong community building'],
      image: 'https://readdy.ai/api/search-image?query=Modern%20fitness%20gym%20interior%20with%20exercise%20equipment%2C%20bright%20lighting%2C%20motivational%20atmosphere%2C%20professional%20fitness%20photography%2C%20clean%20white%20background%2C%20contemporary%20gym%20design&width=600&height=400&seq=project3&orientation=landscape'
    },
    {
      title: 'Paws & Claws Grooming',
      category: 'Pet Services',
      description: 'Showcased adorable before-and-after transformations that went viral, bringing in customers from across the city.',
      results: ['10+ viral posts', '300% booking increase', '8,000+ new followers'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20pet%20grooming%20salon%20interior%20with%20cute%20dogs%2C%20bright%20clean%20environment%2C%20professional%20pet%20photography%2C%20white%20background%2C%20modern%20grooming%20facility%20aesthetic&width=600&height=400&seq=project4&orientation=landscape'
    },
    {
      title: 'Sunset Real Estate',
      category: 'Real Estate',
      description: 'Elevated property listings with professional photography and virtual tours, establishing them as the go-to local realtor.',
      results: ['25 properties sold', '400% inquiry increase', 'Top local realtor ranking'],
      image: 'https://readdy.ai/api/search-image?query=Luxury%20modern%20home%20interior%20with%20elegant%20furnishings%2C%20natural%20lighting%2C%20professional%20real%20estate%20photography%2C%20clean%20white%20background%2C%20high-end%20property%20aesthetic&width=600&height=400&seq=project5&orientation=landscape'
    },
    {
      title: 'Tech Solutions Hub',
      category: 'Technology Services',
      description: 'Simplified complex tech concepts with engaging infographics and tips, positioning them as trusted IT experts.',
      results: ['50+ B2B leads', '250% engagement rate', 'Industry thought leader status'],
      image: 'https://readdy.ai/api/search-image?query=Modern%20technology%20office%20workspace%20with%20computers%20and%20digital%20displays%2C%20professional%20lighting%2C%20clean%20white%20background%2C%20contemporary%20tech%20company%20aesthetic%2C%20minimalist%20design&width=600&height=400&seq=project6&orientation=landscape'
    }
  ];

  const videoSamples = [
    {
      title: 'Restaurant Promo Video',
      category: 'Food & Beverage',
      thumbnail: 'https://readdy.ai/api/search-image?query=Professional%20food%20video%20production%20setup%20with%20delicious%20dishes%2C%20cinematic%20lighting%2C%20restaurant%20kitchen%20background%2C%20video%20camera%20equipment%2C%20clean%20white%20background%2C%20commercial%20food%20photography%20aesthetic&width=400&height=300&seq=video1&orientation=landscape'
    },
    {
      title: 'Fashion Brand Story',
      category: 'Fashion Retail',
      thumbnail: 'https://readdy.ai/api/search-image?query=Fashion%20video%20production%20behind%20the%20scenes%2C%20model%20photoshoot%20setup%2C%20professional%20lighting%20equipment%2C%20modern%20studio%20background%2C%20clean%20white%20background%2C%20commercial%20fashion%20photography%20aesthetic&width=400&height=300&seq=video2&orientation=landscape'
    },
    {
      title: 'Fitness Transformation',
      category: 'Fitness & Wellness',
      thumbnail: 'https://readdy.ai/api/search-image?query=Fitness%20video%20production%20setup%20with%20workout%20equipment%2C%20motivational%20gym%20atmosphere%2C%20professional%20video%20lighting%2C%20clean%20white%20background%2C%20commercial%20fitness%20photography%20aesthetic&width=400&height=300&seq=video3&orientation=landscape'
    },
    {
      title: 'Real Estate Tour',
      category: 'Real Estate',
      thumbnail: 'https://readdy.ai/api/search-image?query=Real%20estate%20video%20production%20setup%20with%20luxury%20home%20interior%2C%20professional%20camera%20equipment%2C%20elegant%20lighting%2C%20clean%20white%20background%2C%20commercial%20property%20photography%20aesthetic&width=400&height=300&seq=video4&orientation=landscape'
    }
  ];

  const adSamples = [
    {
      title: 'Social Media Ad Campaign',
      category: 'Digital Marketing',
      thumbnail: 'https://readdy.ai/api/search-image?query=Creative%20social%20media%20advertisement%20design%20mockup%2C%20bright%20colorful%20graphics%2C%20modern%20digital%20marketing%20aesthetic%2C%20clean%20white%20background%2C%20professional%20advertising%20design%20layout&width=400&height=300&seq=ad1&orientation=landscape'
    },
    {
      title: 'Instagram Story Series',
      category: 'Social Media',
      thumbnail: 'https://readdy.ai/api/search-image?query=Instagram%20story%20template%20designs%20with%20vibrant%20colors%2C%20modern%20social%20media%20graphics%2C%20clean%20white%20background%2C%20professional%20digital%20marketing%20aesthetic%2C%20mobile-friendly%20layout&width=400&height=300&seq=ad2&orientation=landscape'
    },
    {
      title: 'Facebook Ad Creative',
      category: 'Paid Advertising',
      thumbnail: 'https://readdy.ai/api/search-image?query=Facebook%20advertisement%20creative%20design%20with%20engaging%20visuals%2C%20bright%20marketing%20graphics%2C%20clean%20white%20background%2C%20professional%20social%20media%20advertising%20aesthetic&width=400&height=300&seq=ad3&orientation=landscape'
    },
    {
      title: 'Brand Identity Package',
      category: 'Branding',
      thumbnail: 'https://readdy.ai/api/search-image?query=Brand%20identity%20design%20package%20with%20logo%20and%20marketing%20materials%2C%20colorful%20branding%20elements%2C%20clean%20white%20background%2C%20professional%20graphic%20design%20aesthetic&width=400&height=300&seq=ad4&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-cyan-50 to-blue-50 relative overflow-hidden">
      <VideoBackground />
      <Header />
      
      <main className="relative z-10">
        {/* Hero Section */}
        <section className="py-20 px-6">
          <div className="max-w-6xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-blue-600 via-cyan-500 to-blue-400 bg-clip-text text-transparent">
              Recent Projects
            </h1>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto mb-8">
              See how we've helped small businesses like yours achieve remarkable growth through strategic social media content marketing. These are real results from real businesses.
            </p>
          </div>
        </section>

        {/* Projects Grid */}
        <section className="py-16 px-6">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {projects.map((project, index) => (
                <div
                  key={index}
                  className="bg-white/80 backdrop-blur-sm rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
                >
                  <div className="h-64 overflow-hidden">
                    <img
                      src={project.image}
                      alt={project.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="p-6">
                    <div className="text-sm font-semibold text-blue-600 mb-2">{project.category}</div>
                    <h3 className="text-2xl font-bold mb-3 text-gray-800">{project.title}</h3>
                    <p className="text-gray-600 mb-4">{project.description}</p>
                    <div className="space-y-2">
                      <div className="font-semibold text-gray-800 mb-2">Key Results:</div>
                      {project.results.map((result, idx) => (
                        <div key={idx} className="flex items-center text-sm text-gray-700">
                          <i className="ri-check-double-line text-green-500 mr-2"></i>
                          {result}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Video Samples Gallery */}
        <section className="py-16 px-6 bg-white/60 backdrop-blur-sm">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-4xl font-bold text-center mb-12 bg-gradient-to-r from-blue-600 via-cyan-500 to-blue-400 bg-clip-text text-transparent">
              Video Ad Samples
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {videoSamples.map((video, index) => (
                <div
                  key={index}
                  className="bg-white/80 backdrop-blur-sm rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={video.thumbnail}
                      alt={video.title}
                      className="w-full h-full object-cover object-top"
                    />
                    <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                      <div className="w-16 h-16 flex items-center justify-center bg-white/90 rounded-full">
                        <i className="ri-play-fill text-3xl text-blue-600"></i>
                      </div>
                    </div>
                  </div>
                  <div className="p-4">
                    <div className="text-xs font-semibold text-blue-600 mb-1">{video.category}</div>
                    <h3 className="text-lg font-bold text-gray-800">{video.title}</h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Ad Samples Gallery */}
        <section className="py-16 px-6">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-4xl font-bold text-center mb-12 bg-gradient-to-r from-blue-600 via-cyan-500 to-blue-400 bg-clip-text text-transparent">
              Creative Ad Samples
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {adSamples.map((ad, index) => (
                <div
                  key={index}
                  className="bg-white/80 backdrop-blur-sm rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
                >
                  <div className="h-48 overflow-hidden">
                    <img
                      src={ad.thumbnail}
                      alt={ad.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="p-4">
                    <div className="text-xs font-semibold text-blue-600 mb-1">{ad.category}</div>
                    <h3 className="text-lg font-bold text-gray-800">{ad.title}</h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Carousel Section */}
        <section className="py-16 px-6 bg-white/60 backdrop-blur-sm">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl font-bold text-center mb-12 bg-gradient-to-r from-blue-600 via-cyan-500 to-blue-400 bg-clip-text text-transparent">
              Success Stories Carousel
            </h2>
            <ProjectCarousel />
          </div>
        </section>

        {/* Stats Section */}
        <section className="py-16 px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl font-bold text-center mb-12 bg-gradient-to-r from-blue-600 via-cyan-500 to-blue-400 bg-clip-text text-transparent">
              Our Impact in Numbers
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              {[
                { number: '50+', label: 'Happy Clients' },
                { number: '2,500+', label: 'Content Pieces Created' },
                { number: '150K+', label: 'Engagement Generated' },
                { number: '95%', label: 'Client Satisfaction' }
              ].map((stat, index) => (
                <div key={index} className="text-center bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg">
                  <div className="text-4xl font-bold bg-gradient-to-r from-blue-600 via-cyan-500 to-blue-400 bg-clip-text text-transparent mb-2">
                    {stat.number}
                  </div>
                  <div className="text-gray-600 font-medium">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 px-6">
          <div className="max-w-4xl mx-auto bg-gradient-to-r from-blue-600 via-cyan-500 to-blue-400 rounded-3xl p-12 text-center shadow-2xl">
            <h2 className="text-4xl font-bold text-white mb-6">
              Ready to Be Our Next Success Story?
            </h2>
            <p className="text-xl text-white/90 mb-8">
              Let's create amazing results for your business too. Start with a free consultation!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/consultation"
                className="bg-white text-blue-600 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-colors duration-300 whitespace-nowrap cursor-pointer"
              >
                Free Consultation
              </Link>
              <Link
                to="/quote"
                className="bg-cyan-400 text-blue-800 px-8 py-4 rounded-full font-bold text-lg hover:bg-cyan-300 transition-colors duration-300 whitespace-nowrap cursor-pointer"
              >
                Request a Quote
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default ProjectsPage;
